import http from "./http";

export const GetSubscription = async() => {
    return await http.get("/subscription/business");
};